import lazySizes from 'lazysizes';
import unveilHooks from './ls.unveilhooks';
import bgSet from './ls.bgset';

document.addEventListener('lazybeforeunveil', (e) => {

  const background = e.target.getAttribute('data-background');
  const background_tablet = e.target.getAttribute('data-background-tablet');
  const background_mobile = e.target.getAttribute('data-background-mobile');
  if (!background && !background_tablet && !background_mobile) {
    return;
  }

  e.target.style.backgroundImage = responsive_image(background, background_tablet, background_mobile);

});

window.addEventListener('resize', responsive_resize);

function init() {
  lazySizes.cfg.loadMode = 1;
  lazySizes.cfg.expand = 1000;
  unveilHooks();
  bgSet();
}

function forceLazySizesInit() {
  const images = document.querySelectorAll('.prelazyload');

  Array.from(images).forEach((image) => {
    lazySizes.loader.unveil(image);
  });
}

function responsive_image(desktop, tablet, mobile) {

  if(!tablet && !mobile) {

    return `url("${desktop}")`;

  } else {

    if(window.innerWidth < 762 && mobile) {

      return `url("${mobile}")`;

    } else if ((window.innerWidth > 762 && window.innerWidth < 1200) &&  tablet) {

      return `url("${tablet}")`;

    } else {

      return `url("${desktop}")`;

    }

  }

}

function responsive_resize() {

  var elements = document.querySelectorAll(".lazyloaded");
    elements.forEach((e) => {

      var background = e.getAttribute('data-background');
      var background_tablet = e.getAttribute('data-background-tablet');
      var background_mobile = e.getAttribute('data-background-mobile');
      if (!background && !background_tablet && !background_mobile) {
        return;
      }

      e.style.backgroundImage = responsive_image(background, background_tablet, background_mobile);


    });

};

export { init, forceLazySizesInit };
